import { setFeatureFlags, IRootState } from './featureFlagsReducer';
import {
  IUserContext,
  FeatureFlagsType,
} from '../../common/interfaces/featureFlags';
import { Store } from 'redux';

let storeInstance: Store<IRootState> | null = null;

export const initializeFeatureFlagsStore = (store: Store<IRootState>) => {
  storeInstance = store;
};

export const setFeatureFlagsFromApi = (
  flags: FeatureFlagsType,
  userContext: IUserContext
) => {
  if (!storeInstance) {
    return;
  }
  storeInstance.dispatch(setFeatureFlags(flags, userContext));
};

export const getAllFlags = (): FeatureFlagsType => {
  if (!storeInstance) {
    return {};
  }
  const state = storeInstance.getState();
  return state.featureFlags.flags;
};
